import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LetDirective } from './directives/let.directive';
import { FuseLoadingBarModule } from '../../@fuse/components/loading-bar';

@NgModule({
  declarations: [LetDirective],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FuseLoadingBarModule],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, FuseLoadingBarModule, LetDirective]
})
export class SharedModule {}
